// Random cart identity, scoped to this origin. Never contains customer or IP data.
const STORAGE_KEY = 'commerce-cart-id'
const valid = (value: unknown): value is string => typeof value === 'string' && /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i.test(value)
let memoryId: string | undefined
let memoryOnly = false

export function getCartIdentity(): string | undefined {
  if (typeof window === 'undefined') return undefined
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY)
    if (valid(saved)) { memoryOnly = false; return (memoryId = saved) }
    if (memoryOnly && memoryId) return memoryId
    // An absent entry after a successful read also reflects another tab clearing it.
    memoryId = undefined
  } catch { if (memoryId) return memoryId }
  try {
    if (window.crypto.randomUUID) memoryId = window.crypto.randomUUID()
    else {
      const bytes = window.crypto.getRandomValues(new Uint8Array(16))
      bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128
      const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('')
      memoryId = `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
    }
    try { window.localStorage.setItem(STORAGE_KEY, memoryId) } catch { memoryOnly = true }
    return memoryId
  } catch { return undefined }
}

export function finishCartIdentity(expected?: string): void {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY)
    if (!expected || saved === expected) window.localStorage.removeItem(STORAGE_KEY)
  } catch { /* Storage restrictions must not affect checkout. */ }
  if (!expected || memoryId === expected) { memoryId = undefined; memoryOnly = false }
}
